module.exports = __webpack_public_path__ + "static/media/rank.c0df406c.svg";